// AccountBookingsSkeleton.jsx — mirrors the real appointments layout
import "../../account.css";
import "./accountBookingsSkeleton.css";

export default function AccountBookingsSkeleton() {
	return (
		<div className="ac-page">
			{/* NEXT APPOINTMENT */}
			<div className="apbk-skel-next">
				<div className="apbk-skel-next-main">
					<div className="apbk-skel-date shimmer" />
					<div className="apbk-skel-copy">
						<div className="apbk-skel-line shimmer w-20" />
						<div className="apbk-skel-line shimmer w-40 is-xl" />
						<div className="apbk-skel-line shimmer w-30" />
						<div className="apbk-skel-line shimmer w-50" />
						<div className="apbk-skel-chips">
							<div className="apbk-skel-chip shimmer" />
							<div className="apbk-skel-chip shimmer" />
						</div>
					</div>
				</div>

				<div className="apbk-skel-next-actions">
					<div className="apbk-skel-btn shimmer" />
					<div className="apbk-skel-btn shimmer" />
				</div>
			</div>

			{/* UPCOMING */}
			<div className="ac-card">
				<div className="ac-card-head">
					<div className="apbk-skel-icon shimmer" />
					<div className="apbk-skel-line shimmer w-40" />
					<div className="apbk-skel-badge shimmer" />
				</div>

				<div className="ac-card-body is-flush">
					{Array.from({ length: 2 }).map((_, i) => (
						<div key={i} className="apbk-skel-card">
							<div className="apbk-skel-copy">
								<div className="apbk-skel-line shimmer w-50 is-lg" />
								<div className="apbk-skel-line shimmer w-70" />
								<div className="apbk-skel-chips">
									<div className="apbk-skel-chip shimmer" />
									<div className="apbk-skel-chip shimmer" />
								</div>
							</div>

							<div className="apbk-skel-actions">
								<div className="apbk-skel-btn shimmer" />
								<div className="apbk-skel-btn shimmer" />
							</div>
						</div>
					))}
				</div>
			</div>

			{/* HISTORY */}
			<div className="ac-card">
				<div className="ac-card-head">
					<div className="apbk-skel-icon shimmer" />
					<div className="apbk-skel-line shimmer w-40" />
				</div>

				<div className="ac-card-body is-flush">
					{Array.from({ length: 3 }).map((_, i) => (
						<div key={i} className="apbk-skel-row">
							<div className="apbk-skel-line shimmer w-20" />
							<div className="apbk-skel-line shimmer w-40" />
							<div className="apbk-skel-line shimmer w-30" />
							<div className="apbk-skel-badge shimmer" />
						</div>
					))}
				</div>
			</div>
		</div>
	);
}
